import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Card, Button, Alert } from 'react-bootstrap';
import { signInRequest } from '../../store/modules/auth/patient/actions';
import logo from '../../assets/logo.png';
import RecuperarSenhaModal from '../../components/RecuperarSenhaModal';

export default function SignInPac() {
  const dispatch = useDispatch();
  const authError = useSelector(state => state.patient.authError);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();

    const cpf = event.currentTarget.elements.formBasicCPF.value;
    const senha = event.currentTarget.elements.formBasicSenha.value;

    if (!cpf || !senha) return;

    dispatch(signInRequest(cpf, senha));
  }

  return (
    <>
      <Card className="m-5 mx-auto" style={{ maxWidth: 350 }}>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <div className="text-center">
              <img src={logo} alt="logo" width={70} height={70} />
            </div>
            <Form.Group controlId="formBasicCPF">
              <Form.Label>CPF do Paciente</Form.Label>
              <Form.Control
                required
                type="text"
                name="cpf"
                inputMode="numeric"
                autoComplete="username"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck={false}
                placeholder="Seu CPF"
              />
            </Form.Group>
            <Form.Group controlId="formBasicSenha">
              <Form.Label>Senha</Form.Label>
              <Form.Control
                required
                type="password"
                name="senha"
                autoComplete="current-password"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck={false}
                placeholder="Sua senha secreta"
              />
            </Form.Group>
            {authError && (
              <Alert variant="danger" className="mb-3">
                {authError}
              </Alert>
            )}
            <Button block type="submit">
              Entrar
            </Button>
            <Button
              variant="info"
              block
              onClick={() => setShowResetPasswordModal(true)}
            >
              Primeiro Acesso
            </Button>
            <Button
              variant="warning"
              block
              onClick={() => setShowResetPasswordModal(true)}
            >
              Esqueci minha senha
            </Button>
          </Form>
        </Card.Body>
      </Card>

      <RecuperarSenhaModal
        showResetPasswordModal={showResetPasswordModal}
        setShowResetPasswordModal={setShowResetPasswordModal}
        userType="paciente"
      />
    </>
  );
}
